import type { Treatment } from "@redotech/redo-storefront-widget-common/split";
import * as z from "zod";

/**
 * Persist the coverage builder's current (possibly unsaved) settings as a
 * split-less preview Treatment, viewable via `?treatment_id=<id>&preview=true`.
 */
export const createCoveragePreviewTreatment = {
  name: "createCoveragePreviewTreatment" as const,
  input: z.object({
    team: z.string(),
    settings: z.custom<Treatment["settings"]>(
      (value) => typeof value === "object" && value !== null,
    ),
  }),
  output: z.object({ treatmentId: z.string() }),
};
